import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { PlantSelectionProvider } from "../../features/plants/PlantSelectionContext";

const DashboardLayout = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth < 768) {
      setIsMobileSidebarOpen((prev) => !prev);
      return;
    }

    setIsSidebarExpanded((prev) => !prev);
  };

  return (
    <PlantSelectionProvider>
    <div className="min-h-screen overflow-x-hidden bg-lightborder">
      <Navbar toggleSidebar={toggleSidebar} />

      <div className="flex min-h-[calc(100vh-64px)]">
        <Sidebar
          expanded={isSidebarExpanded}
          isOpen={isMobileSidebarOpen}
          setIsOpen={setIsMobileSidebarOpen}
        />

        <main className="min-w-0 flex-1 overflow-x-hidden p-3 sm:p-4 lg:p-5">
          <Outlet />
        </main>
      </div>
    </div>
    </PlantSelectionProvider>
  );
};

export default DashboardLayout;
